import Vue from 'vue';
import App from './App.vue';
import dotenv from 'dotenv';
import './assets/tailwind.css';
dotenv.config({ path: '.env.local' });

import vuetify from './plugins/vuetify';
import store from "./store";
import router from './router';

import "./plugins/vuetify-mask";
import "./plugins/apexcharts";

// Componentes globais para sistema de perfis
import UpgradeModal from "./components/UpgradeModal.vue";
import LimitProgressCard from "./components/LimitProgressCard.vue";
import ProBadge from "./components/ProBadge.vue";
import ProExpirationBanner from "./components/ProExpirationBanner.vue";
import ProStatusBadge from "./components/ProStatusBadge.vue";

Vue.component('UpgradeModal', UpgradeModal);
Vue.component('LimitProgressCard', LimitProgressCard);
Vue.component('ProBadge', ProBadge);
Vue.component('ProExpirationBanner', ProExpirationBanner);
Vue.component('ProStatusBadge', ProStatusBadge);

// EventBus global para comunicação entre componentes
Vue.prototype.$eventBus = new Vue();
window.EventBus = Vue.prototype.$eventBus;

// Plugin de verificação de expiração Pro
import proExpirationChecker from './plugins/proExpirationChecker';
Vue.use(proExpirationChecker, { store });

Vue.config.productionTip = false;

// Meta Pixel Integration
const pixelId = process.env.VUE_APP_META_PIXEL_ID;
if (pixelId) {
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');

    router.afterEach(() => {
        window.fbq('track', 'PageView');
    });
}

new Vue({
    store,
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app');
